import type { LexicalEditor } from 'lexical';
import {
  $getSelection,
  $isElementNode,
  $isRangeSelection,
  $isTextNode,
} from 'lexical';

export type LexicalCaretAnchorDom = {
  anchorElement: HTMLElement;
  textOffset: number;
};

export function resolveLexicalCaretAnchorDom({
  editor,
}: {
  editor: LexicalEditor;
}): LexicalCaretAnchorDom | null {
  const selection = $getSelection();
  if (!$isRangeSelection(selection)) {
    return null;
  }

  const anchor = selection.anchor;
  const anchorNode = anchor.getNode();

  if ($isTextNode(anchorNode)) {
    const parent = anchorNode.getParent();
    if (!parent || !$isElementNode(parent)) {
      return null;
    }

    const domElement = editor.getElementByKey(parent.getKey());
    if (!(domElement instanceof HTMLElement)) {
      return null;
    }

    let textOffset = anchor.offset;
    for (const sibling of parent.getChildren()) {
      if (sibling.getKey() === anchorNode.getKey()) {
        break;
      }
      textOffset += sibling.getTextContentSize();
    }

    return { anchorElement: domElement, textOffset };
  }

  if ($isElementNode(anchorNode)) {
    const domElement = editor.getElementByKey(anchorNode.getKey());
    if (!(domElement instanceof HTMLElement)) {
      return null;
    }

    let textOffset = 0;
    const children = anchorNode.getChildren();
    for (let index = 0; index < anchor.offset; index += 1) {
      const child = children[index];
      if (child) {
        textOffset += child.getTextContentSize();
      }
    }

    return { anchorElement: domElement, textOffset };
  }

  return null;
}
